module.exports = __webpack_public_path__ + "static/media/get-in-touch.eaf2f855.svg";